import QRCode from 'qrcode'

function authenticatorQr (otpauthUrl) {

  return QRCode.toDataURL(otpauthUrl, {
    margin: 1,
    width: 220,
    errorCorrectionLevel: 'M',
    color: {
      dark: '#141412',
      light: '#ffffff'
    }
  })
}

export { authenticatorQr }
